import { MutationTree } from 'vuex';

import { UserI } from '@/store/auth/state';
import {
  PaymentStateI,
  PaymentI,
} from './state';

export const mutations: MutationTree<PaymentStateI> = {
  setPayments(state: PaymentStateI, payload: PaymentI[]) {
    state.payments = payload;
  },
  setPayment(state: PaymentStateI, payload: PaymentI) {
    state.payment = payload;
  },
};
